import { useConfirm } from "./ConfirmProvider";
import { useState } from "react";
import { facturesAPI } from "../services/api";
import { formatRelanceDate } from "./relanceDates";

const LABELS = {
  en_attente: "Envoi initial en attente", en_cours: "Envoi initial à vérifier",
  incertain: "Envoi initial incertain", echec: "Échec de l'envoi initial",
  envoyee: "Facture envoyée", annulee: "Envoi automatique annulé",
};

export default function InvoiceDeliveryStatus({ facture, onChanged }) {
  const confirm = useConfirm();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const delivery = facture.envoi_initial;
  if (!delivery?.historique?.length) return null;

  const perform = async (operation) => {
    setBusy(true);
    setError("");
    try {
      await operation();
    } catch (failure) {
      const detail = failure?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Impossible de modifier l'envoi initial");
    } finally {
      try {
        await onChanged?.();
      } catch {
        setError((current) => current || "Impossible d'actualiser l'historique. Rechargez la page.");
      } finally {
        setBusy(false);
      }
    }
  };
  const verify = async (event, sent) => {
    const question = sent
      ? "Après vérification, confirmez-vous que cette facture a bien été envoyée ? Aucun nouvel email ne sera envoyé."
      : "Après vérification, confirmez-vous que cette facture n'a pas été envoyée ? Un nouvel essai manuel sera possible.";
    if (await confirm(question)) perform(() => facturesAPI.verifyInitialDelivery(facture.id, event.id, sent));
  };

  return <div className="space-y-2 border-b border-gray-200 pb-2">
    <p className={delivery.a_verifier || delivery.etat === "echec" ? "font-medium text-red-700" : "text-gray-600"}>
      {LABELS[delivery.etat] || delivery.etat}
    </p>
    {delivery.erreur && <p className="text-red-700">{delivery.erreur}</p>}
    {error && <p role="alert" className="text-red-700">{error}</p>}
    {delivery.etat === "echec" && !delivery.renvoi_bloque && !delivery.a_verifier && facture.statut !== "annulee" && <button
      type="button" disabled={busy} className="text-primary-700 hover:underline disabled:opacity-50"
      onClick={async () => {
        if (await confirm("Réessayer l'envoi de cette facture au client ?")) perform(() => facturesAPI.sendEmail(facture.id));
      }}>Réessayer l'envoi initial</button>}
    <details open={delivery.a_verifier}>
      <summary className="cursor-pointer text-gray-600">Historique des envois initiaux</summary>
      <ul className="mt-2 space-y-3">
        {[...delivery.historique].reverse().map((event) => <li key={event.id}>
          <p>{formatRelanceDate(event.date, true)} : {LABELS[event.statut] || event.statut}</p>
          <p>{event.mode === "automatique" ? "Automatique" : "Manuel"}{event.destinataire && ` · ${event.destinataire}`}</p>
          {event.erreur && <p className="text-red-700">{event.erreur}</p>}
          {["en_cours", "incertain"].includes(event.statut) && <div className="mt-1 flex flex-wrap gap-2">
            <button type="button" disabled={busy} className="text-primary-700 hover:underline" onClick={() => verify(event, true)}>Envoi initial confirmé</button>
            <button type="button" disabled={busy} className="text-primary-700 hover:underline" onClick={() => verify(event, false)}>Facture non envoyée</button>
          </div>}
        </li>)}
      </ul>
    </details>
  </div>;
}
